// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_18_1-form {
  /* Typography */
  --perxis-auto-form-font-family-inner: var(
    --perxis-auto-form-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-form-font-size-inner: var(
    --perxis-auto-form-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-form-font-weight-inner: var(
    --perxis-auto-form-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-form-letter-spacing-inner: var(
    --perxis-auto-form-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-form-line-height-inner: var(
    --perxis-auto-form-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-form-text-transform-inner: var(
    --perxis-auto-form-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-form-font-variant-numeric-inner: var(
    --perxis-auto-form-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  --perxis-auto-form-color-inner: var(--perxis-auto-form-color, var(--perxis-auto-root-typography-color-darkest-inner));
}
.perxis-auto-1_18_1-form.ant-5_24_1-form {
  font-family: var(--perxis-auto-form-font-family-inner);
  font-size: var(--perxis-auto-form-font-size-inner);
  line-height: var(--perxis-auto-form-line-height-inner);
  font-weight: var(--perxis-auto-form-font-weight-inner);
  text-transform: var(--perxis-auto-form-text-transform-inner);
  letter-spacing: var(--perxis-auto-form-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-form-font-variant-numeric-inner);
  color: var(--perxis-auto-form-color-inner);
}

.perxis-auto-1_18_1-form-item {
  /* Typography */
  --perxis-auto-form-item-font-family-inner: var(
    --perxis-auto-form-item-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-form-item-font-size-inner: var(
    --perxis-auto-form-item-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-form-item-font-weight-inner: var(--perxis-auto-form-item-font-weight, 600);
  --perxis-auto-form-item-letter-spacing-inner: var(
    --perxis-auto-form-item-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-form-item-line-height-inner: var(
    --perxis-auto-form-item-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-form-item-text-transform-inner: var(
    --perxis-auto-form-item-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-form-item-color-inner: var(
    --perxis-auto-form-item-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-form-item-error-font-family-inner: var(
    --perxis-auto-form-item-error-font-family,
    var(--perxis-auto-root-typography-super-small-font-family-inner)
  );
  --perxis-auto-form-item-error-font-size-inner: var(
    --perxis-auto-form-item-error-font-size,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --perxis-auto-form-item-error-font-weight-inner: var(
    --perxis-auto-form-item-error-font-weight,
    var(--perxis-auto-root-typography-super-small-font-weight-inner)
  );
  --perxis-auto-form-item-error-letter-spacing-inner: var(
    --perxis-auto-form-item-error-letter-spacing,
    var(--perxis-auto-root-typography-super-small-letter-spacing-inner)
  );
  --perxis-auto-form-item-error-line-height-inner: var(
    --perxis-auto-form-item-error-line-height,
    var(--perxis-auto-root-typography-super-small-line-height-xxl-inner)
  );
  --perxis-auto-form-item-error-text-transform-inner: var(
    --perxis-auto-form-item-error-text-transform,
    var(--perxis-auto-root-typography-super-small-text-transform-inner)
  );
  --perxis-auto-form-item-error-color-inner: var(
    --perxis-auto-form-item-error-color,
    var(--perxis-auto-root-typography-color-light-colorful-inner)
  );
  --perxis-auto-form-item-mark-color-inner: var(
    --perxis-auto-form-item-mark-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  --perxis-auto-form-item-padding-inner: var(
    --perxis-auto-form-item-padding,
    0 0 var(--perxis-auto-gap-vertical-purple-inner)
  );
  /* End Typography */
}
.perxis-auto-1_18_1-form-item.ant-5_24_1-form-item {
  font-family: var(--perxis-auto-form-item-font-family-inner);
  font-size: var(--perxis-auto-form-item-font-size-inner);
  line-height: var(--perxis-auto-form-item-line-height-inner);
  font-weight: var(--perxis-auto-form-item-font-weight-inner);
  text-transform: var(--perxis-auto-form-item-text-transform-inner);
  letter-spacing: var(--perxis-auto-form-item-letter-spacing-inner);
  color: var(--perxis-auto-form-item-color-inner);
  margin-bottom: 0;
}
.perxis-auto-1_18_1-form-item.ant-5_24_1-form-item .ant-5_24_1-form-item-label {
  padding: var(--perxis-auto-form-item-padding-inner);
}
.perxis-auto-1_18_1-form-item.ant-5_24_1-form-item .ant-5_24_1-form-item-label > label {
  font-style: normal;
  font-family: var(--perxis-auto-form-item-font-family-inner);
  font-size: var(--perxis-auto-form-item-font-size-inner);
  line-height: var(--perxis-auto-form-item-line-height-inner);
  font-weight: var(--perxis-auto-form-item-font-weight-inner);
  text-transform: var(--perxis-auto-form-item-text-transform-inner);
  letter-spacing: var(--perxis-auto-form-item-letter-spacing-inner);
  color: var(--perxis-auto-form-item-color-inner);
}
.perxis-auto-1_18_1-form-item.ant-5_24_1-form-item .ant-5_24_1-form-item-control-input {
  min-height: 50px;
}
.perxis-auto-1_18_1-form-item.ant-5_24_1-form-item .ant-5_24_1-form-item-explain-error {
  font-style: normal;
  font-family: var(--perxis-auto-form-item-error-font-family-inner);
  font-size: var(--perxis-auto-form-item-error-font-size-inner);
  line-height: var(--perxis-auto-form-item-error-line-height-inner);
  font-weight: var(--perxis-auto-form-item-error-font-weight-inner);
  text-transform: var(--perxis-auto-form-item-error-text-transform-inner);
  letter-spacing: var(--perxis-auto-form-item-error-letter-spacing-inner);
  color: var(--perxis-auto-form-item-error-color-inner);
  margin-top: 10px;
}
.perxis-auto-1_18_1-form-item.ant-5_24_1-form-item .ant-5_24_1-form-item-required {
  flex-direction: row-reverse;
}
.perxis-auto-1_18_1-form-item.ant-5_24_1-form-item .ant-5_24_1-form-item-label > label.ant-5_24_1-form-item-required:not(.ant-5_24_1-form-item-required-mark-optional)::before {
  color: var(--perxis-auto-form-item-mark-color-inner);
}
.perxis-auto-1_18_1-form-item.ant-5_24_1-form-item .ant-5_24_1-form-item-label > label::after {
  content: none;
}
.perxis-auto-1_18_1-form-item.ant-5_24_1-form-item.perxis-auto-1_18_1-form-item--hidden-label .ant-5_24_1-form-item-label {
  visibility: hidden;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
